<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="详情"
        width="80%"
        top="0"
        class="customerPurchaseOrder"
        @close="closeTab">
      <div style="margin-bottom: 20px">
        <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息</div>
        <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">采购单号:</td>
            <td>{{purchaseOrder.purchaseOrderNo}}</td>
            <td class="tableLabel">销售单号:</td>
            <td style="width: 23%">{{purchaseOrder.salesOrderNo}}</td>
            <td class="tableLabel">状态:</td>
            <td v-if="status === 0 || status === null">未确认</td>
            <td v-else-if="status === 5">已确认</td>
          </tr>
          <tr>
            <td class="tableLabel">项目类型:</td>
            <td>{{purchaseOrder.projectType}}</td>
            <td class="tableLabel">项目名称:</td>
            <td>{{purchaseOrder.projectName}}</td>
            <td class="tableLabel">交货日期:</td>
            <td v-if="purchaseOrder.deliveryDate !== '' && purchaseOrder.deliveryDate !==null">{{purchaseOrder.deliveryDate.substring(0, 10)}}</td>
            <td v-else>{{purchaseOrder.deliveryDate}}</td>
          </tr>
          <tr>
            <td class="tableLabel">创建时间:</td>
            <td>{{purchaseOrder.createTime}}</td>
            <td class="tableLabel">修改时间:</td>
            <td>{{purchaseOrder.updateTime}}</td>
            <td class="tableLabel">采购:</td>
            <td>{{purchaseOrder.buyUserName}}</td>
          </tr>
        </table>
      </div>
      <el-tabs v-model="tabActive">
        <el-tab-pane label="采购物料" name="first">
          <el-table v-loading="loading" :data="purchaseOrder.materials" border>
            <el-table-column prop="rowIndex" align="center" label="行号" width="60"/>
            <el-table-column align="center" prop="salesOrderNo" label="销售单号" width="100"/>
            <el-table-column prop="materialNo" align="center" label="物料编号" width="150"/>
            <el-table-column
                prop="materialName"
                align="left"
                show-overflow-tooltip
                label="物料名称"/>
            <el-table-column
                prop="specification"
                align="center"
                show-overflow-tooltip
                label="规格"
                width="80"/>
            <el-table-column prop="unit" align="center" label="单位" width="55"/>
            <el-table-column prop="quantity" align="right" label="采购数量" width="80"/>
            <el-table-column prop="receiptQuantity" align="center" label="已收数量" width="80"/>
            <el-table-column prop="price" align="right" label="单价(未税)" width="80">
              <template v-slot="scope">
                <span v-if="scope.row.price !== null">{{scope.row.price}}</span>
                <span v-else>***</span>
              </template>
            </el-table-column>
            <el-table-column prop="amount" align="right" label="小计(未税)" width="80"/>
            <el-table-column
                prop="note"
                align="center"
                width="100"
                show-overflow-tooltip
                label="备注"/>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="物料参数" name="second">
          <el-table v-loading="loading" :data="purchaseOrder.properties" border>
            <el-table-column prop="materialRowIndex" align="center" label="采购订单物料行号" width="120"/>
            <el-table-column prop="groupName" align="left" show-overflow-tooltip label="组名"/>
            <el-table-column
                prop="propertyName"
                align="left"
                width="200"
                show-overflow-tooltip
                label="特性名称"/>
            <el-table-column prop="propertyValue" align="left" show-overflow-tooltip label="特性值"/>
            <el-table-column
                prop="note"
                align="center"
                width="100"
                show-overflow-tooltip
                label="备注"/>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="物料Bom" name="third">
          <el-table v-loading="loading" :data="purchaseOrder.bom" border>
            <el-table-column prop="masterRowIndex" align="center" width="150" label="采购订单物料行号"/>
            <el-table-column
                prop="levelIndex"
                align="center"
                width="150"
                show-overflow-tooltip
                label="层级"/>
            <el-table-column prop="parentMaterialNo" align="center" label="父级物料编号"/>
            <el-table-column prop="parentMaterialName" align="left" show-overflow-tooltip label="父级物料名称"/>
            <el-table-column prop="materialNo" align="center" width="150" label="物料编号"/>
            <el-table-column prop="materialName" align="left" show-overflow-tooltip label="物料名称"/>
            <el-table-column prop="unit" align="center" width="80" label="计量单位"/>
            <el-table-column prop="quantity" align="right" width="80" label="数量"/>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="附件" name="fourth">
          <el-table v-loading="loading" :data="purchaseOrder.attachments" border>
            <el-table-column prop="salesOrderNo" align="center" width="150" label="销售单号"/>
            <el-table-column prop="fileName" align="left" show-overflow-tooltip label="附件名称"/>
            <el-table-column prop="filePath" align="left" show-overflow-tooltip label="附件路径"/>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button v-if="status === 0 || status === null" :loading="submitLoading" type="primary" @click="submit"> 保存 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: "CustomerPurchaseOrderPreview",
    components: {},
    data() {
      return {
        tabActive: "first",
        dialogVisible: false,
        loading: false,
        submitLoading: false,
        status: "",
        purchaseOrder: {
          pkid: 0,
          purchaseOrderNo: "",
          salesOrderNo: "",
          projectType: "",
          projectName: "",
          statusName: "",
          deliveryDate: "",
          createTime: "",
          updateTime: "",
          materials: [],
          properties: [],
          bom: [],
          attachments: [],
        },
        filter: {
          purchaseOrderNo: "",
          customerNo: "",
          customerId: 5316,
          purchaseOrderNoes: [],
          status: -1,
        },
      };
    },
    methods: {
      open(row, customerId) {
        this.filter.purchaseOrderNoes = [];
        this.purchaseOrder = JSON.parse(JSON.stringify(row));
        this.status = row.status;
        this.filter.customerId = JSON.parse(JSON.stringify(customerId));
        this.filter.purchaseOrderNo = JSON.parse(JSON.stringify(row.purchaseOrderNo));
        this.filter.purchaseOrderNoes.push(row.purchaseOrderNo);
        this.getPurchaseOrderList();
        this.dialogVisible = true;
      },
      //获取数据
      getPurchaseOrderList() {
        this.loading = true;
        this.$http
          .post("basic", "crm/po/getPurchaseOrderList", this.filter)
          .then((res) => {
            this.loading = false;
            if (res.success) {
              this.purchaseOrder = res.data[0];
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      //关闭弹框
      closeTab() {
        this.filter.customerId = "";
        this.filter.purchaseOrderNo = "";
        this.filter.purchaseOrderNoes = [];
        this.purchaseOrder.materials = [];
        this.purchaseOrder.properties = [];
        this.purchaseOrder.bom = [];
        this.purchaseOrder.attachments = [];
      },
      //保存
      submit() {
        this.submitLoading = true;
        this.$http
          .post("basic", "crm/po/confirm", this.filter)
          .then((res) => {
            this.filter.purchaseOrderNoes = [];
            this.submitLoading = false;
            if (res.success) {
              this.$message.success("保存成功");
              this.$emit("save-success");
              this.dialogVisible = false;
            }
          })
          .catch(() => {
            this.filter.purchaseOrderNoes = [];
            this.submitLoading = false;
            this.dialogVisible = false;
          });
      },
    },
  };
</script>
<style lang="scss">
.customerPurchaseOrder {
  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #dddddd;
    border-left: none;
    border-bottom: none;
  }
  table.gridtable th {
    text-align: left;
    padding: 8px;
    background-color: #d1e6f5;
  }
  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
    border-top: none;
    border-right: none;
  }
  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #d1e6f5;
  }
}

.customerPurchaseOrder .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.customerPurchaseOrder .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.customerPurchaseOrder .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.customerPurchaseOrder .el-divider--horizontal {
  margin: 10px 0;
}

.customerPurchaseOrder .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>
